import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useOffboardPopupContext } from 'context/OffboardPopupContext';
import { useForm } from 'react-hook-form';

export default function Offboard() {
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        clearErrors,
        setError
    } = useForm();
    const [leaveReasonColor, setLeaveReasonColor] = useState("#d3d3d3"); 
    const [isModalForAddingOtherLeaveReasonOption, setModalForAddingOtherLeaveReasonOption] = useState(false); 
    const [otherLeaveReasonOption, setOtherLeaveReasonOption] = useState(""); 
    const [leaveReason, setLeaveReason] = useState('');
    const [leaveReasons] = useState(['Lack of growth Opportunities', 'Getting better Opportunity', 'Lack of recognition', 'Poor job flexibility', 'Shifting to other location', 'Poor benefits']);
    const [isManualReason, setIsManualReason] = useState(false); 
    const { isExitOpen, toggleExitPopup } = useOffboardPopupContext();
      
    const closeExitPopup = () => {
        toggleExitPopup(false); 
        reset({ exitLeaveReason: '' });
        setLeaveReasonColor("#d3d3d3");
    };

    const handleExitLeaveReasonColorChange = (e) => {
        const selectedLeaveReasonValue = e.target.value;
        setLeaveReason(selectedLeaveReasonValue); 
        setValue("exitLeaveReason", selectedLeaveReasonValue); 
        setLeaveReasonColor(selectedLeaveReasonValue ? "black" : "#d3d3d3");
        clearErrors('exitLeaveReason');

        if (selectedLeaveReasonValue === "other") {
            setModalForAddingOtherLeaveReasonOption(true);
        }
    };

    // submit the exit form
    const handleExitSubmit = () => {
        reset({
            exitLeaveReason: '',
            exitNotifyManager: false
        });
        setTimeout(() => {
            toast.success("Offboarding process has been initialized!");
        },1000);
        setModalForAddingOtherLeaveReasonOption(false);
        clearErrors();
        setLeaveReasonColor("#d3d3d3");
    }

    return (
        <>
            {isExitOpen && (
                <div className="popup-overlay">
                    <div className="popup">
                        <form onSubmit={handleSubmit(handleExitSubmit)}>
                            <div className="exit-heading">
                                <p> Do you really want to leave?</p>
                            </div>
                            <div className="leave-reason-container">
                                <p>Reason for leaving</p>
                                <div>
                                    <select className="exit-select-field" {...register("exitLeaveReason", { required: 'Please choose your leave reason' })}
                                        onChange={handleExitLeaveReasonColorChange}
                                        style={{ color: leaveReasonColor, width: '400px' }} value={leaveReason}>
                                        <option value='' hidden>Choose the leave reason</option>
                                        {leaveReasons.map((name) => (
                                            <option key={name} value={name} style={{ color: 'black' }}>
                                                {name}
                                            </option>
                                        ))}
                                        {isManualReason && (
        <option value={leaveReason} hidden>
            {leaveReason}
        </option>
    )}
                                         
                                        <option style={{ color: 'black' }} value="other" >Add Other reason</option>
                                    </select>
                                    {errors.exitLeaveReason && (<div className="userErrorMessage">{errors.exitLeaveReason.message}</div>)}
                                </div>
                            </div>
                            {isModalForAddingOtherLeaveReasonOption && (
                                <div className='addOtherLeaveReasonForm'>
                                    <div className="textarea-wrapper">
                                        <textarea rows="2" cols="29" className='input-field' value={otherLeaveReasonOption}
                                            placeholder='Add reason here...' onChange={(e) => setOtherLeaveReasonOption(e.target.value)} required />
                                    </div>
                                </div>
                            )}
                            <div className="notify-container">
                                <label>
                                    <input className="input-field" type="checkbox" {...register("exitNotifyManager")} />
                                    <span>Notify Reporting Manager</span>
                                </label>
                            </div>
                            <div className='exit-leave-btn-container'>
                                <button className="primary-btn" type="reset" style={{ background: 'darkgray' }} onClick={closeExitPopup}>Cancel</button>
                                <button className="primary-btn" type="submit" style={{ width: '75px' }}
                                 onClick={() => {
                                    // If adding a manual reason
                                    if (isModalForAddingOtherLeaveReasonOption && otherLeaveReasonOption.trim() !== "") {
                                        setLeaveReason(otherLeaveReasonOption); // Set as the selected value
                                        setIsManualReason(true); // Mark it as manually added
                                        setValue("exitLeaveReason", otherLeaveReasonOption); // Update form value
                                        clearErrors("exitLeaveReason"); // Clear validation errors
                                        setModalForAddingOtherLeaveReasonOption(false); // Close modal
                                        setOtherLeaveReasonOption(""); // Clear modal input
                                    } else if (!leaveReason) {
                                        // Handle case when no reason is selected at all
                                        setError("exitLeaveReason", {
                                            type: "manual",
                                            message: "Please choose your leave reason",
                                        });
                                    }
                                }}
                                >Apply</button>
                            </div>
                        </form>
                    </div>
                    <ToastContainer />
                </div>
            )}
        </>
        
    )
}
